"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("@emotion/react");

var _constants = require("./constants");

const style = /*#__PURE__*/(0, _react.css)("text-align:center;padding:18px 0 14px;background:var(--clock-wrapper-bg, ", _constants.CLOCK_WRAPPER_BACKGROUND, ");" + (process.env.NODE_ENV === "production" ? "" : ";label:style;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3N0eWxlcy9jbG9jay13cmFwcGVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUdpQiIsImZpbGUiOiIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9zdHlsZXMvY2xvY2std3JhcHBlci50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0J1xuaW1wb3J0IHsgQ0xPQ0tfV1JBUFBFUl9CQUNLR1JPVU5EIH0gZnJvbSAnLi9jb25zdGFudHMnXG5cbmNvbnN0IHN0eWxlID0gY3NzYFxuXHR0ZXh0LWFsaWduOiBjZW50ZXI7XG5cdHBhZGRpbmc6IDE4cHggMCAxNHB4O1xuXHRiYWNrZ3JvdW5kOiB2YXIoLS1jbG9jay13cmFwcGVyLWJnLCAke0NMT0NLX1dSQVBQRVJfQkFDS0dST1VORH0pO1xuYFxuXG5leHBvcnQgZGVmYXVsdCBzdHlsZVxuIl19 */");
var _default = style;
exports.default = _default;